import { render, staticRenderFns } from "./contractsPage.vue?vue&type=template&id=15a4d556&"
import script from "./contractsPage.vue?vue&type=script&lang=js&"
export * from "./contractsPage.vue?vue&type=script&lang=js&"
import style0 from "./contractsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports